import { render, staticRenderFns } from "./newListDetail.vue?vue&type=template&id=05305f57&scoped=true&"
import script from "./newListDetail.vue?vue&type=script&lang=js&"
export * from "./newListDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "05305f57",
  null
  
)

export default component.exports